import { createAction, props } from '@ngrx/store'

const SOURCE = '[Auth]'

export const authSetAccessToken = createAction(
    `${ SOURCE } authSetAccessToken`,
    props<{accessToken: string}>()
)

export const reset = createAction(`${ SOURCE } reset`)
